import React, {
  useEffect,
  useState,
} from 'react';
import './TareDistribution.css';
import { useStores } from '../../hooks/use-stores';
import { DeviceStatus } from '../../constants/DeviceStatus';
import logger from '../../utils/logger';
import { withTranslation } from 'react-i18next';

const TareDistribution = (props) => {
  const [ visible, setVisible ] = useState(true);
  const [ error, setError ] = useState('');
  const [ values, setValues ] = useState({});
  const { batchStore } = useStores();
  const { scale = {}, status, unit, t } = props;
  const weight = Number(props.weight) || 0;
  const scaleQueue = batchStore.scaleQueue[scale.id];
  const runningData = scaleQueue && scaleQueue.length ? scaleQueue[0] : null;
  const materials = runningData && runningData.scales ? runningData.scales[scale.id].map(v => v.material) : [];

  useEffect(() => {
    if (status === DeviceStatus.IDLE || status === DeviceStatus.FINISH) {
      setVisible(true);
      setValues({});
    }
  }, [status]);

  const updateValue = (materialCode, value = 0) => {
    setError('');

    setValues({
      ...values,
      [materialCode]: value,
      [`${materialCode}-qty`]: weight * value/100,
    });
  };

  const save = () => {
    setError('');

    let total = 0;
    materials.forEach(m => {
      total += Number(values[m.code] || 0);
    });

    if (total !== 100) {
      setError(t('Total must be 100%'));
      return;
    }

    materials.forEach((m, i) => {
      const index = runningData.scales[scale.id].findIndex(v => v.material.code === m.code);
      const data = runningData.scales[scale.id][index];
      const percent = Number(values[m.code]) || 0;

      if (!data) {
        logger.warn(`Tare distribution: no batch data for scale: ${scale.description}, material: ${m.code}`);
        return;
      }

      const deductionWeight = percent ? weight * percent/100 : 0;
      let newTarget;

      if (percent === 100 && weight > data.mft) {
        newTarget = data.mft;
        runningData.scales[scale.id][index].targetDeduction = data.mft;
      } else if (i === 0) {
        newTarget = data.mft >= deductionWeight ? data.mft + (weight - deductionWeight) : 0;
        runningData.scales[scale.id][index].targetDeduction = deductionWeight * -1;
      } else {
        newTarget = data.mft >= deductionWeight ? data.mft - deductionWeight : 0;
        runningData.scales[scale.id][index].targetDeduction = deductionWeight;
      }

      runningData.scales[scale.id][index].mft = newTarget;

      logger.log(`Tare distribution: ${m.code} ${percent}%`, 'target:', data.mft, 'deduction:', deductionWeight,
        'new target:', newTarget, 'scale weight:', weight);

    });

    setVisible(false);
  };

  return status !== DeviceStatus.NOT_EMPTY || !scale.startTareDistribution || !materials.length ? '' : (
    <div className="tare-distribution">
      <div>
        <h5>{t('Tare distribution')}</h5>
      </div>
      {!!visible
        ? (
          <div className="tare-distribution-details">
            {materials.map((m, index) => (
              <label key={index}>
                <span>{m.code} {values[m.code] || 0}% = {values[`${m.code}-qty`] || 0}{unit}</span>
                <input type="range"
                  min="0"
                  max="100"
                  step="10"
                  value={values[m.code] || 0}
                  onMouseDown={e => e.stopPropagation()}
                  onChange={e => {
                    e.stopPropagation();
                    updateValue(m.code, e.target.value);
                  }}/>
              </label>
            ))}

            {!!error &&
            <p className="error">{error}</p>
            }

            <div className="btn-wrap">
              <button className="btn-save" onClick={() => save()}>{t('Save')}</button>
            </div>
          </div>
        )
        : (
          <div className="tare-distribution-details">
            {materials.map((m, index) => (
              <label key={index}>
                <span>{m.code} {values[m.code] || 0}% = {values[`${m.code}-qty`] || 0}{unit}</span>
              </label>
            ))}
            <p>{t('Please press Override (F2)')}</p>
          </div>
        )}
    </div>
  );
};

export default withTranslation()(TareDistribution);
